import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivateChild, RouterStateSnapshot} from '@angular/router';
import {Observable} from 'rxjs';
import {filter, map, take} from 'rxjs/operators';
import {Usuario, Wso2IntegrationService} from '@mapa/core';

/**
 * AuthGuard que sempre retorna "true", ou seja, sempre permite que o usuário acesse a página requisitada,
 * mas só depois de carregar e preparar o usuário logado para evitar que a página faça requisições antes disso.
 */
@Injectable({
    providedIn: 'root'
})
export class EnsureUserLoadedGuard implements CanActivateChild {

    constructor(private wso2IntegrationService: Wso2IntegrationService) {
    }

    canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        return this.wso2IntegrationService.usuario.pipe(
            filter<Usuario>(value => !!value),
            take<Usuario>(1),
            map<Usuario, boolean>(() => {
                return true;
            })
        );
    }

}
